import React from 'react';
import './ConnectionLost.scss';

const ConnectionLost = () => {

	const [ show, setShow ] = React.useState( 'block' );

	function  closeForm() {
		setShow( 'none' );
	}

	return (
		<div className="form-popup" style={{display:show}}>
			<div className="form-container">
				<p>Connection to server lost but you may see the static contents</p>
				<button type="button" className="btn" onClick={closeForm}>Close</button>
			</div>
		</div>
	);
}

export default ConnectionLost;

